export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/5ba84b7c5997e2a9223c26a23a6fa17e.svg";